import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=29d66f74&scoped=true"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=29d66f74&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d66f74",
  null
  
)

export default component.exports